/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Input,
  Container,
  CardHeader,
  CardFooter,
  Button,
  Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function CreateAcquirer(props) {
  const token = localStorage.token;
  const id = props.match.params.id;
  const [hostType, setHostType] = useState("");
  const [hostTypeError, setHostTypeError] = useState(null);
  const [cardType, setCardType] = useState("");
  const [cardTypeError, setCardTypeError] = useState(null);
  const [encyptionType, setEncyptionType] = useState("");
  const [encyptionTypeError, setEncyptionTypeError] = useState(null);
  const [primaryIp, setPrimaryIp] = useState("");
  const [primaryIpError, setPrimaryIpError] = useState(null);
  const [secondaryIp, setSecondaryIp] = useState("");
  const [secondaryIpError, setSecondaryIpError] = useState(null);
  const [primartPort, setPrimaryPort] = useState("");
  const [primartPortError, setPrimaryPortError] = useState(null);
  const [secondaryPort, setSecondaryPort] = useState("");
  const [secondaryPortError, setSecondaryPortError] = useState(null);
  const [primaryNii, setPrimaryNii] = useState("");
  const [primaryNiiError, setPrimaryNiiError] = useState(null);
  const [secondaryNii, setSecondaryNii] = useState("");
  const [secondaryNiiError, setSecondaryNiiError] = useState(null);
  const [hostTypes, setHostTypes] = useState([]);
  const [types, setTypes] = useState([]);
  let history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const validateForm = () => {
    let error = false;
    if (hostType === "") {
      setHostTypeError("invalid");
      error = true;
    }
    if (cardType === "") {
      setCardTypeError("invalid");
      error = true;
    }
    if (encyptionType === "") {
      setEncyptionTypeError("invalid");
      error = true;
    }
    if (primaryIp === "") {
      setPrimaryIpError("invalid");
      error = true;
    }
    if (secondaryIp === "") {
      setSecondaryIpError("invalid");
      error = true;
    }
    if (primartPort === "") {
      setPrimaryPortError("invalid");
      error = true;
    }
    if (secondaryPort === "") {
      setSecondaryPortError("invalid");
      error = true;
    }
    if (primaryNii === "") {
      setPrimaryNiiError("invalid");
      error = true;
    }
    if (secondaryNii === "") {
      setSecondaryNiiError("invalid");
      error = true;
    }
    return error;
  };

  useEffect(() => {
    getHostType();
  }, []);

  const getHostType = () => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/transtypes`, {
      method: 'GET', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(),
    })
      .then(response => response.json())
      .then(data => {
        setHostTypes(data.response_data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const getTypesList = (hostType) => {
    const data = { transtype_name: hostType }
    fetch(`${process.env.REACT_APP_API_BASE_URL}/transtypes/list`, {
      method: 'POST', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setTypes(data.response_data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function CreateAcquirerHost() {
    setLoading(true);
    let data = {
      acquirer_id: parseInt(id),
      acquirer_host_type: hostType,
      transtype_id: parseInt(cardType),
      encryption_type: encyptionType,
      primary_ip: primaryIp,
      secondary_ip: secondaryIp,
      primary_port: parseInt(primartPort),
      secondary_port: parseInt(secondaryPort),
      primary_nii: primaryNii,
      secondary_nii: secondaryNii
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/host/save`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        history.push("/admin/acquirer");
      })
      .then(json => {
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      CreateAcquirerHost();
    }
  }
  return (
    <>
      <SimpleHeader name="Daftar Acquirer Host" parentName="Admin" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit} >
                  <CardHeader>
                    <h3>Daftar Acquirer Host</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="acquirer_host_type"
                      >
                        Host Type
                                            </Label>
                      <Input
                        id="exampleFormControlSelect3"
                        name="transaction_type"
                        type="select"
                        value={hostType}
                        invalid={hostTypeError === "invalid"}
                        onChange={(e) => {
                          setHostType(e.target.value);
                          if (e.target.value !== "") {
                            setHostTypeError("");
                          }
                          getTypesList(e.target.value);
                        }}
                      >
                        <option value="">Pilih Host Type</option>
                        {
                          hostTypes.map((hostType, key) => {
                            return <option key={key} value={hostType.transtype_name}>{hostType.transtype_name}</option>
                          })
                        }
                      </Input>
                      <FormFeedback>Host Type tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="encryption_type"
                      >
                        Card Type
                                            </Label>
                      <Input
                        id="exampleFormControlSelect3"
                        name="transtype_id"
                        type="select"
                        value={cardType}
                        invalid={cardTypeError === "invalid"}
                        onChange={(e) => {
                          setCardType(e.target.value);
                          if (e.target.value !== "") {
                            setCardTypeError("");
                          }
                        }}
                      >
                        <option value="">Pilih Card Type</option>
                        {
                          types.map((type, key) => {
                            return <option key={key} value={type.transtype_id}>{type.transtype_clsf}</option>
                          })
                        }
                      </Input>
                      <FormFeedback>Card Type tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="encryption_type"
                      >
                        Encyption Type
                                            </Label>
                      <Input
                        type="text"
                        name="encryption_type"
                        placeholder="Masukan Encyption Type"
                        value={encyptionType}
                        invalid={encyptionTypeError === "invalid"}
                        onChange={(e) => {
                          setEncyptionType(e.target.value);
                          if (e.target.value !== "") {
                            setEncyptionTypeError("");
                          }
                        }}
                      />
                      <FormFeedback>Encyption Type tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        IP Primary
                                            </Label>
                      <Input
                        type="text"
                        name="primary_ip"
                        placeholder="Masukan Primary IP"
                        value={primaryIp}
                        invalid={primaryIpError === "invalid"}
                        onChange={(e) => {
                          setPrimaryIp(e.target.value);
                          if (e.target.value !== "") {
                            setPrimaryIpError("");
                          }
                        }}
                      />
                      <FormFeedback>IP Primary tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        IP Secondary
                                            </Label>
                      <Input
                        type="text"
                        name="secondary_ip"
                        placeholder="Masukan Secondary IP"
                        value={secondaryIp}
                        invalid={secondaryIpError === "invalid"}
                        onChange={(e) => {
                          setSecondaryIp(e.target.value);
                          if (e.target.value !== "") {
                            setSecondaryIpError("");
                          }
                        }}
                      />
                      <FormFeedback>IP Seconadry tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        Port Primary
                                            </Label>
                      <Input
                        type="text"
                        name="primary_port"
                        placeholder="Masukan Primary Port"
                        value={primartPort}
                        invalid={primartPortError === "invalid"}
                        onChange={(e) => {
                          setPrimaryPort(e.target.value);
                          if (e.target.value !== "") {
                            setPrimaryPortError("");
                          }
                        }}
                      />
                      <FormFeedback>Port Primary tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        Port Secondary
                                            </Label>
                      <Input
                        type="text"
                        name="secondary_port"
                        placeholder="Masukan Secondary Port"
                        value={secondaryPort}
                        invalid={secondaryPortError === "invalid"}
                        onChange={(e) => {
                          setSecondaryPort(e.target.value);
                          if (e.target.value !== "") {
                            setSecondaryPortError("");
                          }
                        }}
                      />
                      <FormFeedback>Port Secondary tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        NII Primary
                                            </Label>
                      <Input
                        type="text"
                        name="primary_nii"
                        placeholder="Masukan Primary NII"
                        value={primaryNii}
                        invalid={primaryNiiError === "invalid"}
                        onChange={(e) => {
                          setPrimaryNii(e.target.value);
                          if (e.target.value !== "") {
                            setPrimaryNiiError("");
                          }
                        }}
                      />
                      <FormFeedback>NII Primary tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        NII Secondary
                                            </Label>
                      <Input
                        type="text"
                        name="secondary_nii"
                        placeholder="Masukan Secondary NII"
                        value={secondaryNii}
                        invalid={secondaryNiiError === "invalid"}
                        onChange={(e) => {
                          setSecondaryNii(e.target.value);
                          if (e.target.value !== "") {
                            setSecondaryNiiError("");
                          }
                        }}
                      />
                      <FormFeedback>NII Secondary tidak boleh kosong</FormFeedback>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    {!isLoading && (<Button color="primary" type="submit">
                      Simpan
                    </Button>)}
                    {isLoading && (<Button color="primary" disabled>
                      <i className="fas fa-spinner fa-spin"></i>{""}
                      loading...
                    </Button>)}
                    <Link className="btn btn-info" to="/admin/acquirer">
                      Kembali
                                        </Link>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
